import React, { FC } from 'react';
import Create from 'components/fields/components/Create';

const Screen: FC = () => (
  <Create
    fieldsEntityName="client-fields"
    fieldsDropdownsEntityName="client-field-dropdowns"
    fieldsDropdownsEntityEndpoint="client-fields/dropdown-options"
  />
);

export default Screen;
